import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ForgotPasswordLink: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="flex justify-end mt-1">
            <Link
                to="/auth/forgot-password"
                className="text-sm font-medium text-brand-primary hover:text-brand-primary/80 transition-colors"
            >
                {t('auth.forgotPassword')}
            </Link>
        </div>
    );
};

export default ForgotPasswordLink;
